<template>
  <div
    class="footer"
    :style="
      Object.prototype.hasOwnProperty.call($route.meta, 'footColor')
        ? 'background-color:' + $route.meta.footColor
        : ''
    "
  >
    <div class="footer-content">
      <div class="footer-item" v-for="(item, index) in dataList" :key="index">
        <span>{{ item.name }}</span>
        <span
          style="cursor: pointer"
          v-for="(it, ind) in item.newsInfoVoList"
          :key="ind"
          @click="$router.push({ path: '/infoDetails', query: { id: it.id } })"
          >{{ it.title }}</span
        >
      </div>
    </div>
    <span class="copyright">
      版权所有：江苏省苏合农产品集团有限公司 |
      <a
        style="color: #6e6e6e"
        href="https://beian.miit.gov.cn"
        target="_blank"
      >
        苏ICP备19034215号-2
      </a>
      | 经营执照：苏B-20190577
    </span>
    <span class="copyright" style="margin-top: 24px">
      本网站由江苏天合云商有限公司 运营维护
    </span>
  </div>
</template>

<script>
import { doPost } from "./HttpHelper.js";
import { httpConfig } from "./config.js";
export default {
  data() {
    return {
      dataList: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var that = this;
      doPost(
        httpConfig.Footer.getListUrl,
        { location: 1 },
        function(res) {
          that.dataList = res;
        },
        function(res) {}
      );
    }
  }
};
</script>

<style scoped>
.footer {
  /* margin-top: 25px; */
  width: 100%;
  /* height: 261px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  padding: 35px 0;
  box-sizing: border-box;
}

.footer-content {
  width: 1200px;
  display: flex;
  /* justify-content: space-between; */
}

.footer-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-item span {
  display: flex;
}
.footer-item span:first-child {
  font-size: 20px;
  font-family: PingFang, PingFang-Bold;
  font-weight: 700;
  color: #333333;
  margin-bottom: 20px;
}

.footer-item span:nth-child(n + 2) {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #6e6e6e;
  margin-bottom: 15px;
}
.copyright {
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #6e6e6e;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue